import { render, staticRenderFns } from "./TCMList.vue?vue&type=template&id=38c4ad6f&scoped=true&"
import script from "./TCMList.vue?vue&type=script&lang=js&"
export * from "./TCMList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c4ad6f",
  null
  
)

export default component.exports